/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import withErrorStatus from '../../../shared/StatusWrappers/ErrorStatus';
import withLoadingStatus from '../../../shared/StatusWrappers/LoadingStatus';
import {
  ICarbonScopeOneData,
  IDetailComponentProps,
  IDetailComponentPropsTwoTableSeparate
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { Card } from '@scuf/common';
import { CarbonScopeOneSavingsByMeterComponentContent } from '../CarbonScopeOneSavingsByMeterWidget/CarbonScopeOneSavingsByMeterComponent';

const CarbonScopeTwoSavingsByMeterComponentWithLoader = withLoadingStatus(
  withErrorStatus(CarbonScopeOneSavingsByMeterComponentContent)
);

const CarbonScopeTwoSavingsByMeterComponentSeparate = (
  props: IDetailComponentPropsTwoTableSeparate
) => {
  const { dataConnector, dataConnectorTable, UtilityBillType, scope } = props;

  const [t] = useTranslation();
  const d = descriptors.energyManagement;

  const allTable = dataConnectorTable?.data.all;
  const loadingTable = dataConnectorTable.data.loading;
  const errorTable = dataConnectorTable.data.error;
  const statusTable = dataConnectorTable.data.status;

  const carbonScopeTwoSiteData = (allTable as unknown) as ICarbonScopeOneData;
  const isDataAvailableTable =
    carbonScopeTwoSiteData && carbonScopeTwoSiteData.breakdownByMeter
      ? true
      : false;

  const [isLoadingTable, setIsLoadingTable] = useState<boolean>(loadingTable);
  const [statusCodeTable, setStatusCodeTable] = useState<number | null>(0);
  const [errorInfoTable, setErrorInfoTable] = useState(errorTable);
  const [dataTable, setDataTable] = useState({} as ICarbonScopeOneData);

  const onRefreshTable = () =>
    dataConnectorTable &&
    dataConnectorTable.actions &&
    dataConnectorTable.actions.getAll();

  useEffect(() => {
    setIsLoadingTable(loadingTable);
    if ((isDataAvailableTable || errorTable || statusTable) && !loadingTable) {
      if (isDataAvailableTable) {
        let tempData: any = carbonScopeTwoSiteData;
        setDataTable(tempData);
      }
      setErrorInfoTable(errorTable);
      setStatusCodeTable(statusTable);
    }
  }, [isDataAvailableTable, loadingTable, statusTable]);

  return (
    <Card className="Savemeter">
      <Card.Header className="emaas-carbon-view-details-total-emissions-savings-meter-card-header">
        {t(d.breakdownCarbon)}
      </Card.Header>
      <Card.Content>
        <div className="meter-savings-Datatable detail-view">
          <CarbonScopeTwoSavingsByMeterComponentWithLoader
            loading={isLoadingTable}
            error={errorInfoTable}
            statusCode={statusCodeTable}
            onRefresh={onRefreshTable}
            data={dataTable}
            loadingText={t(d.LOADING)}
            title={t(d.CONNECTIONERRORTITLE)}
            noDataMessage={t(d.NODATAAVAILABLE)}
            connectionErrorMessage={t(d.CONNECTIONERROR)}
            UtilityBillType={UtilityBillType}
            scope={scope}
          />
        </div>
      </Card.Content>
    </Card>
  );
};
export default CarbonScopeTwoSavingsByMeterComponentSeparate;
